import React from 'react';
import { useSurveyStore } from '../surveyutilities/surveyStore';

const TOOLS = [
    { key: 'text', icon: 'bi-input-cursor-text', label: 'Single-line' },
    { key: 'textarea', icon: 'bi-textarea-t', label: 'Multi-line' },
    { key: 'single_choice', icon: 'bi-ui-radios', label: 'Radio' },
    { key: 'multiple_choice', icon: 'bi-ui-checks', label: 'Checkbox' },
    { key: 'dropdown', icon: 'bi-menu-button-wide', label: 'Dropdown' },
    { key: 'rating', icon: 'bi-star', label: 'Rating' },
];

function EcxSurveyToolbar() {
    const addQuestion = useSurveyStore((state) => state.addQuestion);

    return (
        <>
            {TOOLS.map((item) => (
                <button
                    key={item.key}
                    type="button"
                    className="ecx-survey-editor__tool"
                    title={item.label}
                    onClick={() => addQuestion(item.key)}
                >
                    <i className={`bi ${item.icon}`} />
                    <span>{item.label}</span>
                </button>
            ))}
        </>
    );
}

export default EcxSurveyToolbar;
